import { render } from "./EliminationSettingDetails.vue?vue&type=template&id=277ac9f0&ts=true"
import script from "./EliminationSettingDetails.vue?vue&type=script&lang=ts"
export * from "./EliminationSettingDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__